import React from 'react';

import UserRegisterComposer from '../../../composers/UserRegisterComposer';

export default function UserRegisterPage(): JSX.Element {
  return <UserRegisterComposer />;
}
